/**
 * Internal pseudo-step key used to represent the success state.
 * Round-tripped to the URL slug `success` by `createStepKeyParser`.
 */
export const SUCCESS_STEP_KEY = '__success';

/**
 * URL slug used in the `s` query param when the form is on the success step.
 */
export const SUCCESS_STEP_SLUG = 'success';

/**
 * Internal pseudo-step for the HubSpot meeting embed inside the stepped form.
 * Round-tripped to `book-meeting` in the `s` query param.
 */
export const MEETING_ASIDE_KEY = '__meeting_aside';

/** Reserved URL slug — do not use as a Tina step name slug. */
export const MEETING_ASIDE_SLUG = 'book-meeting';